import { Button, Flex, Icon, IconButton, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconClose, IconBan } from 'assets/icons';
import { FloatingFooter } from 'components/Table';

interface IActivateTableFooter {
  selectedFlatRows: any[];
  updatedSelectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleBulkDeactivate: (value: any[]) => void;
  handleBulkTrackMileage: (value: any[]) => void;
  handleBulkTrackLocation: (value: any[]) => void;
}

const ActiveTableFooter: React.FC<IActivateTableFooter> = ({
  selectedFlatRows,
  updatedSelectedFlatRows,
  toggleAllRowSelected,
  handleBulkDeactivate,
  handleBulkTrackLocation,
  handleBulkTrackMileage,
}) => {
  const { t } = useTranslation(['common', 'employees']);

  return (
    <FloatingFooter>
      <Flex alignItems="center">
        <IconButton
          aria-label="Close button"
          icon={<Icon as={IconClose} h="10px" w="10px" />}
          onClick={() => toggleAllRowSelected(false)}
          variant="unstyled"
        />
        <Text>
          ({updatedSelectedFlatRows.length}) {t('common:selected')}
        </Text>
      </Flex>
      <Flex alignItems="center" gridGap={4}>
        <Button onClick={() => handleBulkTrackMileage(selectedFlatRows)} size="sm" variant="secondary-ghost">
          {t('employees:trackUntrackMileage')}
        </Button>
        <Button onClick={() => handleBulkTrackLocation(selectedFlatRows)} size="sm" variant="secondary-ghost">
          {t('employees:trackUntrackLocation')}
        </Button>
        <Button
          leftIcon={<Icon as={IconBan} />}
          size="sm"
          fontSize="sm"
          bg="rgba(101, 104, 134, 0.1)"
          variant="ghost"
          color="newGray.1000"
          _hover={{ bg: 'rgba(101, 104, 134, 0.2)' }}
          onClick={() => handleBulkDeactivate(updatedSelectedFlatRows)}
        >
          {t('employees:deactivateUsers')}
        </Button>
      </Flex>
    </FloatingFooter>
  );
};

export default ActiveTableFooter;
